import React, { useCallback } from "react";

const FormattedCell = ({ value }) => {
  const formatCellValue = useCallback((value) => {
    if (value === undefined || value === null) {
      return "-";
    }

    if (!value.includes("\n")) {
      return value;
    }

    const paragraphs = value.split("\n").filter((p) => p.trim() !== "");

    const formattedParagraphs = paragraphs.map((paragraph) => {
      if (/^\d+\./.test(paragraph)) {
        const items = paragraph.split("\n");
        return `<ol>${items
          .map((item) => `<li>${item.trim()}</li>`)
          .join("")}</ol>`;
      } else {
        return `<p>${paragraph}</p>`;
      }
    });

    return formattedParagraphs.join("");
  }, []);

  const formattedValue = formatCellValue(value);

  return (
    <div
      className="formatted-cell"
      dangerouslySetInnerHTML={{ __html: formattedValue }}
    />
  );
};

export default FormattedCell;
